import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import type { ContentViewerSession } from './schemas'

/**
 * Content Viewer State
 *
 * `session` separates the document being rendered from the context that opened it.
 */
export type ContentViewerState = {
  session: ContentViewerSession | null
}

const initialState: ContentViewerState = {
  session: null,
}

/**
 * Content Viewer Slice
 */
export const contentViewerSlice = createSlice({
  name: 'contentViewerState',
  initialState,
  reducers: {
    // Clear Content Viewer.
    clearContentViewer: (state) => {
      state.session = null
    },

    setContentViewerSession: (state, action: PayloadAction<{ session: ContentViewerSession }>) => {
      state.session = action.payload.session
    },
  },
})

// Actions
export const ContentViewerActions = contentViewerSlice.actions

export default contentViewerSlice.reducer
